<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <Button @click="showMenuAddModal" type="primary" icon="md-add">新增子菜单</Button>
      <Button
        @click="backMenu"
        type="primary"
        style="margin-left:5px"
        v-if="menuIds.length > 1"
      >返回上一级</Button>
      <!-- {{JSON.stringify(menuIds)}} -->
      <Table
        border
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        style="margin-top:10px"
        @on-row-click="rowSelect"
      >
        <template slot-scope="{row}" slot="icon">
          <!-- <Button :icon="row.icon"  type="text" size="large">{{row.icon}}</Button> -->
          <Icon :type="row.icon" size="18" />
        </template>
        <template slot-scope="{row}" slot="opt">
          <Button size="small" @click.stop="deleteMenu(row)">删除</Button>
          <Button size="small" @click.stop="editMenu(row)" style="margin-left:5px">修改</Button>
          <Button size="small" @click.stop="roleSet(row)" style="margin-left:5px">角色</Button>
          <Button
            size="small"
            @click.stop="menuStatusSet(row)"
            style="margin-left:5px"
            v-if="row.status == 1"
          >禁用</Button>
          <Button
            size="small"
            @click.stop="menuStatusSet(row)"
            style="margin-left:5px"
            v-else-if="row.status == 0"
            type="error"
          >启用</Button>
        </template>
      </Table>
    </Card>
    <Modal title="新增子菜单" v-model="addMenuModal.modal" @on-visible-change="onAddModalVisible">
      <Form :label-width="80">
        <FormItem label="菜单名称">
          <Input v-model="addMenuModal.model.name" />
        </FormItem>
        <FormItem label="菜单图标">
          <Input v-model="addMenuModal.model.icon" />
        </FormItem>
        <FormItem label="排序号">
          <Input v-model="addMenuModal.model.ordernumber" />
        </FormItem>
        <FormItem label="路径">
          <Input v-model="addMenuModal.model.path" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="addMenuCancel">取消</Button>
        <Button type="primary" size="large" @click="addMenuSubmit">确定</Button>
      </div>
    </Modal>
    <Modal title="编辑菜单" v-model="editMenuModal.modal" @on-visible-change="onEditModalVisible">
      <Form :label-width="80">
        <FormItem label="菜单名称">
          <Input v-model="editMenuModal.model.name" />
        </FormItem>
        <FormItem label="菜单图标">
          <Input v-model="editMenuModal.model.icon" />
        </FormItem>
        <FormItem label="排序号">
          <Input v-model="editMenuModal.model.ordernumber" />
        </FormItem>
        <FormItem label="路径">
          <Input v-model="editMenuModal.model.path" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editMenuCancel">取消</Button>
        <Button type="primary" size="large" @click="editMenuSubmit">确定</Button>
      </div>
    </Modal>
    <Modal title="菜单角色设置" v-model="roleSetModal.modal" @on-visible-change="onRoleSetModalVisible">
      <Checkbox
        v-for="item in roleSetModal.model"
        :key="item.roleid"
        :label="item.rolename"
        v-model="item.has"
      >{{item.rolename}}</Checkbox>
      <div slot="footer">
        <Button type="text" size="large" @click="roleSetCancel">取消</Button>
        <Button type="primary" size="large" @click="roleSetSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addMenuModal: {
        modal: false,
        model: {},
      },
      editMenuModal: {
        modal: false,
        model: {},
      },
      roleSetModal: {
        modal: false,
        model: {},
        currentMenuId: "",
      },
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "菜单名称",
            key: "name",
          },
          {
            title: "菜单图标",
            slot: "icon",
          },
          {
            title: "菜单路径",
            key: "path",
          },
          {
            title: "排序号",
            key: "ordernumber",
          },
          {
            title: "操作",
            slot: "opt",
          },
        ],
      },
      menuIds: [],
    };
  },
  methods: {
    showMenuAddModal() {
      this.addMenuModal.modal = true;
    },
    addMenuCancel() {
      this.addMenuModal.modal = false;
    },
    addMenuSubmit() {
      let _this = this;
      let parentid = this.menuIds[this.menuIds.length - 1];
      this.$http.post({
        method: "/base/menu/add",
        params: {
          name: this.addMenuModal.model.name,
          icon: this.addMenuModal.model.icon,
          path: this.addMenuModal.model.path,
          ordernumber: this.addMenuModal.model.ordernumber,
          parentid: parentid,
        },
        success: function (data) {
          _this.addMenuModal.modal = false;
          _this.refreshCurrentMenu();
        },
        failure(code, msg) {
          _this.$Message.warning(msg);
        },
      });
    },
    editMenuCancel() {
      this.editMenuModal.modal = false;
    },
    editMenuSubmit() {
      let _this = this;
      this.$http.post({
        method: "/base/menu/updateMenu",
        params: this.editMenuModal.model,
        success: function (data) {
          _this.editMenuModal.modal = false;
          _this.refreshCurrentMenu();
        },
      });
    },
    enterSubMenu(parentid) {
      this.menuIds.push(parentid);
      this.getSubMenu(parentid);
    },
    getSubMenu(parentid) {
      let _this = this;
      this.$http.get({
        method: "/base/menu/getSubMenuList",
        params: {
          parentid: parentid,
        },
        success: function (data) {
          _this.tdata.current_data = data;
        },
      });
    },
    rowSelect(row) {
      this.enterSubMenu(row.id);
    },
    backMenu() {
      if (this.menuIds.length > 1) {
        this.menuIds.pop();
        this.refreshCurrentMenu();
      }
    },
    deleteMenu(row) {
      let _this = this;
      this.$Modal.confirm({
        title: "提示",
        content: "确定删除该菜单吗？",
        onOk: () => {
          _this.$http.post({
            method: "/base/menu/delete",
            params: {
              id: row.id,
            },
            success: function (data) {
              _this.refreshCurrentMenu();
            },
            failure(code, msg) {
              _this.$Message.warning(msg);
            },
          });
        },
      });
    },
    editMenu(row) {
      this.editMenuModal.modal = true;
      this.editMenuModal.model = row;
    },
    onEditModalVisible(visible) {
      if (!visible) {
        this.editMenuModal.model = {};
      }
    },
    onAddModalVisible() {
      this.addMenuModal.model = {};
    },
    roleSet(row) {
      let _this = this;
      this.roleSetModal.currentMenuId = row.id;
      this.$http.get({
        method: "/base/menu/getSingleMenuRoleRelation",
        params: {
          menuid: row.id,
        },
        success: function (data) {
          _this.roleSetModal.modal = true;
          _this.roleSetModal.model = data;
        },
      });
    },
    onRoleSetModalVisible(visible) {
      if (!visible) {
        this.roleSetModal.model = {};
      }
    },
    roleSetCancel() {
      this.roleSetModal.modal = false;
    },
    roleSetSubmit() {
      let _this = this;
      let roles = [];
      for (let i = 0; i < this.roleSetModal.model.length; i++) {
        if (this.roleSetModal.model[i].has) {
          roles.push(this.roleSetModal.model[i].roleid);
        }
      }
      this.$http.post({
        method: "/base/menu/setMenuRole",
        params: {
          menuid: this.roleSetModal.currentMenuId,
          roles: roles,
        },
        success: function (data) {
          _this.roleSetModal.modal = false;
        },
        failure(code, msg) {
          _this.$Message.warning(msg);
        },
      });
    },
    menuStatusSet(row) {
      let _this = this;
      if (row.status == 1) {
        this.$http.post({
          method: "/base/menu/updateStatusDisable",
          params: { id: row.id },
          success: function (data) {
            _this.refreshCurrentMenu();
          },
        });
      } else if (row.status == 0) {
        this.$http.post({
          method: "/base/menu/updateStatusEnable",
          params: { id: row.id },
          success: function (data) {
            _this.refreshCurrentMenu();
          },
        });
      }
    },
    refreshCurrentMenu() {
      this.getSubMenu(this.menuIds[this.menuIds.length - 1]);
    },
  },
  mounted() {
    this.enterSubMenu("");
  },
};
</script>